export const textSearch = 'Поиск по госномеру или марке';

export const modes = {
  transports: 'transports',
  permits: 'permits',
};
